import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { QuoteGateway } from '../gateway/quote.gateway';

export interface QuoteDTO {
  estimatedRentalPeriod: string;
  numberOfUnits: string;
  projectLocation: string;
  deliveryDate: string;
  message: string;
  title: string;
  firstName: string;
  surname: string;
  telephone: string;
  email: string;
  companyName: string;
  country: string;
  debtorNumber: string;
  address: string;
  postcode: string;
  city: string;
}

@Injectable({
  providedIn: 'any',
})
export class QuoteFacade {
  private quoteGateway = inject(QuoteGateway);

  submitForm(formData: QuoteDTO, productNumber: string): Observable<any> {
    return this.quoteGateway.submitForm(formData, productNumber);
  }
}
